import api from '../api'

export default {
  async loadList (context) {
    api.formular.list().then((response) => {
      context.commit('listCommit', response)
    })
  },
  async loadListByNetwork (context, payload) {
    return api.formular.list(payload).then((response) => {
      context.commit('listByNetworkCommit', response)
    })
  },
  async loadTypeList (context) {
    api.formular.listType().then((response) => {
      context.commit('listTypeCommit', response)
    })
  },
  async loadTypeListByNetwork (context, payload) {
    api.formular.listType(payload).then((response) => {
      context.commit('listTypeByNetworkCommit', response)
    })
  }
}
